<template>
  <div
    class="modal fade"
    id="commitModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="commitModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="commitWork">
          <div class="modal-header">
            <h3 name="header">Commit Work Logs</h3>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="form-group">
                <p>Current lock time: {{currentLockTime}}</p>
                <p>
                  By selecting a time here, you are commiting all work before that time.
                  <strong>This means that you will no longer be able to add or edit work logs before the selected time.</strong>
                </p>
                <p>
                  Times are in
                  <strong>UTC</strong>.
                </p>
                <hr />
                <label for="date">Commit work before:</label>
                <div class="row">
                  <div class="col-md-6">
                    <input
                      type="date"
                      name="commit_time"
                      id="commit_time"
                      class="form-control"
                      v-model="date"
                      tabindex="-1"
                    />
                  </div>
                  <div class="col-md-6">
                    <input type="time" name="time_start" id="time_start" v-model="time" class="form-control"/>
                  </div>
                  <hr />
                </div>
                <div  class="mt-3">
                  <label>Quick dates:</label>
                  <div class="btn-group">
                    <a class="btn btn-light btn-sm" href="#" @click.prevent="setToSalaryCutoff">Salary cutoff (28th)</a>
                    <a class="btn btn-light btn-sm" href="#" @click.prevent="setToInvoiceCutoff">Invoice cutoff (1st)</a>
                    <a class="btn btn-light btn-sm" href="#" @click.prevent="setToNow">Now</a>
                  </div>
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-sm btn-light" data-dismiss="modal">Close</button>
              <button class="btn btn-sm btn-primary">Commit</button>
            </slot>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import {showSuccess, showError} from 'perform-base/js/flashes';

export default {
  data() {
    return {
      time: null,
      date: null,
    }
  },
  props: [
    'currentLockTime',
  ],
  created() {
    this.setToNow();
  },
  methods: {
    commitWork: function() {
      if (!confirm(`Are you sure you want to commit all work before ${this.date} ${this.time}?`)) {
        return
      }
      axios.post('/api/work-logs/commit-work/', {
        date: this.date,
        time: this.time,
      }).then((response) => {
        showSuccess(response.data.message)
      })
      .catch((error) => {
        showError(error.response.data.message);
      });
    },
    setToNow() {
      const now = new Date();
      this.time = now.toISOString().substr(11, 5);
      this.date = now.toISOString().substr(0, 10);
    },
    setToSalaryCutoff() {
      const cutoff = (new Date())
      cutoff.setDate(28);
      this.time = '00:00';
      this.date = cutoff.toISOString().substr(0, 10);
    },
    setToInvoiceCutoff() {
      const cutoff = (new Date())
      cutoff.setDate(1);
      this.time = '00:00';
      this.date = cutoff.toISOString().substr(0, 10);
    },
  }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/Modal.vue